// extracted by mini-css-extract-plugin
module.exports = {"content":"SingleItemFacet_content__Gow3a","contentMobile":"SingleItemFacet_contentMobile__fldrC"};